import { create } from "zustand";
import type { AgentModel } from "@src/generated/prisma/models";

interface AgentStore {
  online: Record<string, boolean>;
  agents: AgentModel[];
  nameMap: Record<string, string>;
  setAgents: (agents: AgentModel[]) => void;
  setOnline: (online: Record<string, boolean>) => void;
}


export const useAgentStore = create<AgentStore>((set) => {
  return {
    online: {},
    agents: [],
    nameMap: {},
    setAgents(agents) {
      set({ agents, nameMap: Object.fromEntries(agents.map(e => [e.id, e.name])) });
    },
    setOnline(online) {
      set({ online: online || {} });
    },
  }
})
